export * from "./crypto";
export * from "./passkey";
export * from "./queue";
export * from "./storage";
export * from "./vault";

import { rpIdFor, WebAuthnPrfAuthenticator } from "./passkey";
import { createVaultStorage } from "./storage";
import { Vault, type VaultOptions } from "./vault";

// The page's vault: IndexedDB records + real WebAuthn, RP id from the host.
export function createBrowserVault(options: Partial<VaultOptions> = {}): Vault {
  const hostname = typeof window !== "undefined" ? window.location.hostname : "localhost";
  return new Vault(createVaultStorage(), new WebAuthnPrfAuthenticator(), {
    rpId: options.rpId ?? rpIdFor(hostname),
    ...options,
  });
}
